import { Dispatch, FC, SetStateAction } from 'react';
import { NotificationType, NotificationV3, Locale, NotificationTypeV3 } from '#types';
import { useSafeState } from '#hooks';
import { ConfirmationSendNotificationV3 } from './confirmationSendNotificationV3.component';

interface ComposeNotificationProps {
    isConfirmationOpen: boolean;
    setIsConfirmationOpen: Dispatch<SetStateAction<boolean>>;
    userID: number;
}

export const ComposeNotificationV3: FC<ComposeNotificationProps> = ({ isConfirmationOpen, setIsConfirmationOpen, userID }) => {

    const [notification, setNotification] = useSafeState<NotificationV3>({
        userID,
        type: NotificationTypeV3.APP_NEWS,
        lang: Locale.ENGLISH,
        payload: {
            // title: '',
            // body: '',
            discountPercent: 0,
            promoCode: '',
            name: '',
        }
    } as NotificationV3)

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setIsConfirmationOpen(true);
    }

    return <>
        {
            !isConfirmationOpen && <div className='main-dashboard-container pd-m'>
                <form onSubmit={handleSubmit}>
                    {
                        notification.type === NotificationTypeV3.WELCOME && <div>
                            <label htmlFor='title'>Name: </label>
                            <input
                                type='text'
                                id='notification-title-input'
                                name='title'
                                className='pl-m'
                                value={notification.payload.name}
                                onChange={e => setNotification(prev => ({ ...prev, payload: { ...prev.payload, name: e.target.value } }))}
                            />
                        </div>
                    }
                    {
                        notification.type !== NotificationTypeV3.APP_NEWS && <div>
                            <label htmlFor='title'>Promo Code: </label>
                            <input
                                type='text'
                                id='notification-title-input'
                                name='promoCode'
                                className='pl-m'
                                value={notification.payload.promoCode}
                                onChange={e => setNotification(prev => ({ ...prev, payload: { ...prev.payload, promoCode: e.target.value } }))}
                            />
                        </div>
                    }
                    {
                        notification.type !== NotificationTypeV3.APP_NEWS && <div>
                            <label htmlFor='title'>Discount %: </label>
                            <input
                                type='number'
                                id='notification-title-input'
                                name='discountPercent'
                                className='pl-m'
                                value={notification.payload.discountPercent}
                                onChange={e => setNotification(prev => ({ ...prev, payload: { ...prev.payload, discountPercent: Number(e.target.value) } }))}
                            />
                        </div>
                    }
                    <div className='three-columns-expand-three'>
                        <label htmlFor='type'>Notification Type: </label>
                        <div className='three-rows-expand-one-three ml-m'>
                            <div />
                            <select
                                id='selectDropDown'
                                value={notification.type}
                                onChange={(event) => setNotification(prevNotification => ({ ...prevNotification, type: event.target.value as NotificationTypeV3 }))}
                            >
                                {
                                    Object.values(NotificationTypeV3).map(
                                        (notificationType: string) => <option value={notificationType} key={notificationType}>
                                            {notificationType}
                                        </option>
                                    )
                                }
                            </select>
                            <div />
                        </div>
                        <div />
                    </div>
                    {/* {
                        notification.recipients !== RecipientType.INDIVIDUAL &&
                        <div className='three-columns-expand-three'>
                            <label htmlFor='type'>Language: </label>
                            <div className='three-rows-expand-one-three ml-m'>
                                <div />
                                <select
                                    id='selectDropDownLang'
                                    value={notification.lang}
                                    onChange={(event) => setNotification(prevNotification => ({ ...prevNotification, lang: event.target.value as Locale }))}
                                >
                                    {
                                        getRelevantLanguages(currentDb, true).map(
                                            (lang: Locale) => <option value={lang} key={lang}>
                                                {getRelevantLanguageDisplay(lang)}
                                            </option>
                                        )
                                    }
                                </select>
                                <div />
                            </div>
                            <div />
                        </div>
                    } */}
                    <input id="send-notification-button" type="submit" value="SEND" />
                </form>
            </div>
        }
        {
            isConfirmationOpen && <ConfirmationSendNotificationV3
                setIsConfirmationOpen={setIsConfirmationOpen}
                notification={notification}
            />
        }
    </>
}
